import customer from './customer'
import recentConversations from './recentConversations'
import customProfile from './customProfile'
import openState from './openState'
import changeUser from './changeUser'

export default {
  customer,
  recentConversations,
  customProfile,
  openState,
  changeUser,
}

export * as customer from './customer'
export * as recentConversations from './recentConversations'
export * as customProfile from './customProfile'
export * as openState from './openState'
export * as changeUser from './changeUser'
